import React, { Component } from 'react';
import CrclContext from './CrclContext';

const DEFAULT_STATE = {
  sex: '',
  age: '',
  weight: '',
  height: '',
  creatinine: '',
  crcl: '',
  crclActual: '',
  crclSub: '',
  crclClass: '',
  crclSubActual: '',
  crclSubIdeal: '',
  idealWeight: '',
  anticoagulationText: '',
  prophylaxisText: '',
  validationText: {},
  alertDialog: false,
  alertTitle: '',
  //calcStop: false,
};

class CrclProvider extends Component {
  constructor(props) {
    super(props);
    this.updateState = this.updateState.bind(this);
    this.state = {...DEFAULT_STATE, ...props.state, update: this.updateState, resetState: this.resetState};
  }

  updateState(values) {
    this.setState(values);
  }

  resetState() {
    this.setState(DEFAULT_STATE);
  }

  render() {
    return (
      <CrclContext.Provider value={this.state}>
        {this.props.children}
      </CrclContext.Provider>
    );
  }
}

export default CrclProvider;
